{
  "consent.action-accept": "Tillat",
  "consent.action-reject": "Avslå",
  "consent.description": "Gi kun tillatelser hvis du stoler på dette nettstedet eller appen. Du trenger ikke å godta alle tillatelser.",
  "consent.privacy-policy-label": "Personvernerklæring",
  "consent.remember-label": "Husk denne avgjørelsen til neste gang. Applikasjonen vil ikke kunne be om flere tillatelser uten ditt samtykke.",
  "consent.remember-tooltip": "husk mitt valg",
  "consent.requested-permissions-label": "Applikasjonen ber om tilgang til følgende tillatelser:",
  "consent.terms-of-service-label": "Vilkår for bruk",
  "error.back-button": "Gå tilbake",
  "error.description": "En feil oppstod med følgende melding:",
  "error.support-email-link": "Hvis problemet vedvarer, vennligst kontakt <a>{contactSupportEmail}</a>",
  "error.title": "En feil oppstod",
  "error.title-internal-server-error": "Intern serverfeil",
  "error.title-not-found": "404 - Siden ble ikke funnet",
  "identities.messages.1010001": "Logg inn",
  "identities.messages.1010002": "Logg inn med {provider}",
  "identities.messages.1010003": "Vennligst bekreft denne handlingen ved å verifisere at det er deg.",
  "identities.messages.1010004": "Vennligst fullfør den andre autentiseringsutfordringen.",
  "identities.messages.1010005": "Bekreft",
  "identities.messages.1010006": "Autentiseringskode",
  "identities.messages.1010007": "Backup gjenopprettingskode",
  "identities.messages.1010008": "Fortsett med sikkerhetsnøkkel",
  "identities.messages.1010009": "Fortsett",
  "identities.messages.1010010": "Fortsett",
  "identities.messages.1010011": "Logg inn med sikkerhetsnøkkel",
  "identities.messages.1010012": "Forbered din WebAuthn-enhet (f.eks. sikkerhetsnøkkel, biometrisk skanner, ...) og trykk fortsett.",
  "identities.messages.1010013": "Fortsett",
  "identities.messages.1010014": "En kode har blitt sendt til adressen du oppga. Hvis du ikke har mottatt en melding, sjekk stavemåten på adressen og prøv å logge inn på nytt.",
  "identities.messages.1010015": "Send innloggingskode",
  "identities.messages.1010016": "Du prøvde å logge inn med \"{duplicateIdentifier}\", men den e-posten er allerede brukt av en annen konto. Logg inn på kontoen din med et av alternativene nedenfor for å legge til kontoen din \"{duplicateIdentifier}\" hos \"{provider}\" som en annen måte å logge inn på.",
  "identities.messages.1010017": "Logg inn og koble til",
  "identities.messages.1010018": "Bekreft med {provider}",
  "identities.messages.1010019": "Be om kode for å fortsette",
  "identities.messages.1010021": "Logg inn med passkey",
  "identities.messages.1010022": "Logg inn med passord",
  "identities.messages.1010023": "Send kode til {address}",
  "identities.messages.1040001": "Registrer deg",
  "identities.messages.1040002": "Registrer deg med {provider}",
  "identities.messages.1040003": "Fortsett",
  "identities.messages.1040004": "Registrer deg med sikkerhetsnøkkel",
  "identities.messages.1040005": "En kode har blitt sendt til adressen(e) du oppga. Hvis du ikke har mottatt en melding, sjekk stavemåten på adressen og prøv å registrere deg på nytt.",
  "identities.messages.1040006": "Send registreringskode",
  "identities.messages.1040007": "Registrer deg med passkey",
  "identities.messages.1040008": "Tilbake",
  "identities.messages.1040009": "Vennligst velg en legitimasjon for å autentisere deg.",
  "identities.messages.1050001": "Endringene dine er lagret!",
  "identities.messages.1050002": "Koble til {provider}",
  "identities.messages.1050003": "Koble fra {provider}",
  "identities.messages.1050004": "Koble fra TOTP-autentiseringsapp",
  "identities.messages.1050005": "Autentiseringsapp QR-kode",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Vis backup gjenopprettingskoder",
  "identities.messages.1050008": "Aktiver",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Dette er dine backup gjenopprettingskoder. Vennligst oppbevar dem på et trygt sted!",
  "identities.messages.1050011": "Bekreft backup gjenopprettingskoder",
  "identities.messages.1050012": "Legg til sikkerhetsnøkkel",
  "identities.messages.1050013": "Navn på sikkerhetsnøkkel",
  "identities.messages.1050014": "Hemmeligheten ble brukt {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Deaktiver denne metoden",
  "identities.messages.1050017": "Autentiseringshemmelighet",
  "identities.messages.1050018": "Fjern sikkerhetsnøkkel \"{display_name}\"",
  "identities.messages.1050019": "Legg til passkey",
  "identities.messages.1050020": "Fjern passkey \"{display_name}\"",
  "identities.messages.1060001": "Du har gjenopprettet kontoen din. Vennligst endre passordet ditt eller sett opp en alternativ innloggingsmetode (f.eks. sosial innlogging) innen de neste {privileged_session_expires_at_unix_until_minutes} minuttene.",
  "identities.messages.1060002": "En e-post med en gjenopprettingslenke har blitt sendt til e-postadressen du oppga. Hvis du ikke har mottatt en e-post, sjekk stavemåten på adressen og sørg for å bruke adressen du registrerte deg med.",
  "identities.messages.1060003": "En e-post med en gjenopprettingskode har blitt sendt til e-postadressen du oppga. Hvis du ikke har mottatt en e-post, sjekk stavemåten på adressen og sørg for å bruke adressen du registrerte deg med.",
  "identities.messages.1070001": "Passord",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Lagre",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Send inn",
  "identities.messages.1070006": "Bekreft kode",
  "identities.messages.1070007": "E-post",
  "identities.messages.1070008": "Send kode på nytt",
  "identities.messages.1070009": "Fortsett",
  "identities.messages.1070010": "Gjenopprettingskode",
  "identities.messages.1070011": "Verifiseringskode",
  "identities.messages.1070012": "Registreringskode",
  "identities.messages.1070013": "Innloggingskode",
  "identities.messages.1070014": "Logg inn og koble legitimasjon",
  "identities.messages.1070015": "Vennligst fullfør captcha-utfordringen for å fortsette.",
  "identities.messages.1080001": "En e-post med en verifiseringslenke har blitt sendt til e-postadressen du oppga. Hvis du ikke har mottatt en e-post, sjekk stavemåten på adressen og sørg for å bruke adressen du registrerte deg med.",
  "identities.messages.1080002": "Du har bekreftet e-postadressen din.",
  "identities.messages.1080003": "En e-post med en verifiseringskode har blitt sendt til e-postadressen du oppga. Hvis du ikke har mottatt en e-post, sjekk stavemåten på adressen og sørg for å bruke adressen du registrerte deg med.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Vennligst skriv inn {property} og prøv igjen.",
  "identities.messages.4000003": "lengden må være >= {min_length}, men fikk {actual_length}",
  "identities.messages.4000004": "matcher ikke mønsteret \"{pattern}\"",
  "identities.messages.4000005": "Passordet kan ikke brukes fordi {reason}.",
  "identities.messages.4000006": "De oppgitte legitimasjonene er ugyldige, sjekk for skrivefeil i passord, brukernavn, e-postadresse eller telefonnummer.",
  "identities.messages.4000007": "En konto med samme identifikator (e-post, telefon, brukernavn, ...) eksisterer allerede.",
  "identities.messages.4000008": "Den oppgitte autentiseringskoden er ugyldig, vennligst prøv igjen.",
  "identities.messages.4000009": "Fant ingen innloggingsidentifikatorer. Glemte du å sette dem? Dette kan også skyldes en serverfeil.",
  "identities.messages.4000010": "Kontoen er ikke aktiv ennå. Glemte du å bekrefte e-postadressen din?",
  "identities.messages.4000011": "Du har ingen TOTP-enhet satt opp.",
  "identities.messages.4000012": "Denne backup gjenopprettingskoden er allerede brukt.",
  "identities.messages.4000013": "Du har ingen WebAuthn-enhet satt opp.",
  "identities.messages.4000014": "Du har ingen backup gjenopprettingskoder satt opp.",
  "identities.messages.4000015": "Denne kontoen eksisterer ikke eller har ingen sikkerhetsnøkkel satt opp.",
  "identities.messages.4000016": "Backup gjenopprettingskoden er ikke gyldig.",
  "identities.messages.4000017": "lengden må være <= {max_length}, men fikk {actual_length}",
  "identities.messages.4000018": "må være >= {minimum} men fant {actual}",
  "identities.messages.4000019": "må være > {minimum} men fant {actual}",
  "identities.messages.4000020": "må være <= {maximum} men fant {actual}",
  "identities.messages.4000021": "må være < {maximum} men fant {actual}",
  "identities.messages.4000022": "{actual} er ikke et multiplum av {base}",
  "identities.messages.4000023": "maksimalt {max_items} elementer tillatt, men fant {actual_items} elementer",
  "identities.messages.4000024": "minst {min_items} elementer kreves, men fant {actual_items} elementer",
  "identities.messages.4000025": "elementene på indeks {index_a} og {index_b} er like",
  "identities.messages.4000026": "forventet {allowed_types_list}, men fikk {actual_type}",
  "identities.messages.4000027": "En konto med samme identifikator (e-post, telefon, brukernavn, ...) eksisterer allerede. Vennligst logg inn på din eksisterende konto for å koble din sosiale profil.",
  "identities.messages.4000028": "Du prøvde å logge inn med {credential_identifier_hint} som allerede er i bruk av en annen konto. Du kan logge inn med {available_credential_types_list}. Du kan logge inn med en av følgende sosiale innloggingsleverandører: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "må være lik konstanten {expected}",
  "identities.messages.4000030": "const feilet",
  "identities.messages.4000031": "Passordet kan ikke brukes fordi det er for likt identifikatoren.",
  "identities.messages.4000032": "Passordet må være minst {min_length} tegn langt, men fikk {actual_length}.",
  "identities.messages.4000033": "Passordet må være maksimalt {max_length} tegn langt, men fikk {actual_length}.",
  "identities.messages.4000034": "Passordet har blitt funnet i datalekkasjer og må ikke lenger brukes.",
  "identities.messages.4000035": "Denne kontoen eksisterer ikke eller har ikke satt opp innlogging med kode.",
  "identities.messages.4000036": "De oppgitte egenskapene samsvarer ikke med egenskapene som tidligere var tilknyttet denne flyten.",
  "identities.messages.4000037": "Denne kontoen eksisterer ikke eller har ingen innloggingsmetode konfigurert.",
  "identities.messages.4000038": "Captcha-verifisering mislyktes, vennligst prøv igjen.",
  "identities.messages.4010001": "Innloggingsflyten utløp for {expired_at_unix_since_minutes} minutter siden, vennligst prøv igjen.",
  "identities.messages.4010002": "Fant ingen strategi for å logge deg inn. Fylte du ut skjemaet riktig?",
  "identities.messages.4010003": "Fant ingen strategi for å registrere deg. Fylte du ut skjemaet riktig?",
  "identities.messages.4010004": "Fant ingen strategi for å oppdatere innstillingene dine. Fylte du ut skjemaet riktig?",
  "identities.messages.4010005": "Fant ingen strategi for å gjenopprette kontoen din. Fylte du ut skjemaet riktig?",
  "identities.messages.4010006": "Fant ingen strategi for å verifisere kontoen din. Fylte du ut skjemaet riktig?",
  "identities.messages.4010007": "Forespørselen ble allerede fullført og kan ikke gjentas.",
  "identities.messages.4010008": "Innloggingskoden er ugyldig eller har allerede blitt brukt. Vennligst prøv igjen.",
  "identities.messages.4010009": "Koblede legitimasjoner samsvarer ikke.",
  "identities.messages.4010010": "Adressen du oppga samsvarer ikke med noen kjente adresser i den nåværende kontoen.",
  "identities.messages.4040001": "Registreringsflyten utløp for {expired_at_unix_since_minutes} minutter siden, vennligst prøv igjen.",
  "identities.messages.4040002": "Forespørselen ble allerede fullført og kan ikke gjentas.",
  "identities.messages.4040003": "Registreringskoden er ugyldig eller har allerede blitt brukt. Vennligst prøv igjen.",
  "identities.messages.4050001": "Innstillingsflyten utløp for {expired_at_unix_since_minutes} minutter siden, vennligst prøv igjen.",
  "identities.messages.4060001": "Forespørselen ble allerede fullført og kan ikke gjentas.",
  "identities.messages.4060002": "Gjenopprettingsflyten nådde en feiltilstand og må gjentas.",
  "identities.messages.4060004": "Gjenopprettingstokenet er ugyldig eller har allerede blitt brukt. Vennligst prøv flyten på nytt.",
  "identities.messages.4060005": "Gjenopprettingsflyten utløp for {expired_at_unix_since_minutes} minutter siden, vennligst prøv igjen.",
  "identities.messages.4060006": "Gjenopprettingskoden er ugyldig eller har allerede blitt brukt. Vennligst prøv igjen.",
  "identities.messages.4070001": "Verifiseringstokenet er ugyldig eller har allerede blitt brukt. Vennligst prøv flyten på nytt.",
  "identities.messages.4070002": "Forespørselen ble allerede fullført og kan ikke gjentas.",
  "identities.messages.4070003": "Verifiseringsflyten nådde en feiltilstand og må gjentas.",
  "identities.messages.4070005": "Verifiseringsflyten utløp for {expired_at_unix_since_minutes} minutter siden, vennligst prøv igjen.",
  "identities.messages.4070006": "Verifiseringskoden er ugyldig eller har allerede blitt brukt. Vennligst prøv igjen.",
  "identities.messages.5000001": "{reason}",
  "login.cancel-button": "Avbryt",
  "login.cancel-label": "Ikke riktig konto?",
  "login.forgot-password": "Glemt passord?",
  "login.logged-in-as-label": "Du bruker:",
  "login.logout-button": "Logg ut",
  "login.logout-label": "Noe fungerer ikke?",
  "login.registration-button": "Registrer deg",
  "login.registration-label": "Har du ikke en konto?",
  "login.subtitle-oauth2": "For å autentisere {clientName}",
  "login.title": "Logg inn",
  "login.subtitle": "Logg inn med {parts}",
  "login.title-aal2": "Tofaktorautentisering",
  "login.subtitle-aal2": "Velg en måte å fullføre tofaktorautentisering",
  "login.code.subtitle": "En verifiseringskode vil bli sendt på e-post",
  "login.webauthn.subtitle": "Vennligst forbered din WebAuthN-enhet",
  "login.totp.subtitle": "Vennligst skriv inn koden generert av din autentiseringsapp",
  "login.lookup_secret.subtitle": "Vennligst skriv inn en av dine 8-sifrede backup gjenopprettingskoder",
  "login.title-refresh": "Reautentiser",
  "login.subtitle-refresh": "Bekreft din identitet med {parts}",
  "login.2fa.go-back": "Noe fungerer ikke?",
  "login.2fa.go-back.link": "Gå tilbake",
  "login.2fa.method.go-back": "Velg en annen metode",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nei",
  "logout.title": "Ønsker du å logge ut?",
  "recovery.login-button": "Logg inn",
  "recovery.login-label": "Husker du legitimasjonen din?",
  "recovery.title": "Gjenopprett kontoen din",
  "recovery.subtitle": "Skriv inn e-postadressen tilknyttet kontoen din for å motta en engangskode",
  "registration.login-button": "Logg inn",
  "registration.login-label": "Har du allerede en konto?",
  "registration.subtitle-oauth2": "For å autentisere {clientName}",
  "registration.title": "Registrer en konto",
  "registration.subtitle": "Registrer deg med {parts}",
  "settings.navigation-back-button": "Tilbake",
  "settings.navigation-backup-codes": "2FA backupkoder",
  "settings.navigation-logout": "Logg ut",
  "settings.navigation-oidc": "Sosial innlogging",
  "settings.navigation-password": "Passord",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Autentiseringsapp",
  "settings.navigation-webauthn": "Maskinvaretokener",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Her kan du administrere innstillinger relatert til kontoen din. Vær oppmerksom på at enkelte handlinger krever at du autentiserer deg på nytt.",
  "settings.subtitle": "Oppdater kontoinnstillingene dine",
  "settings.title-lookup-secret": "Administrer 2FA backup gjenopprettingskoder",
  "settings.title-navigation": "Kontoinnstillinger",
  "settings.title-oidc": "Sosial innlogging",
  "settings.title-password": "Endre passord",
  "settings.title-profile": "Profilinnstillinger",
  "settings.title-totp": "Administrer 2FA TOTP-autentiseringsapp",
  "settings.title-webauthn": "Administrer maskinvaretokener",
  "settings.title-passkey": "Administrer passkeys",
  "settings.title": "Kontoinnstillinger",
  "settings.navigation.title": "Kontoinnstillinger",
  "settings.password.title": "Endre passord",
  "settings.password.description": "Endre passordet ditt",
  "settings.profile.title": "Profilinnstillinger",
  "settings.profile.description": "Oppdater profilinformasjonen din",
  "settings.webauthn.title": "Administrer maskinvaretokener",
  "settings.webauthn.description": "Administrer innstillingene for maskinvaretokener",
  "verification.registration-button": "Registrer deg",
  "verification.registration-label": "Har du ikke en konto?",
  "verification.title": "Bekreft kontoen din",
  "verification.subtitle": "Skriv inn e-postadressen tilknyttet kontoen din for å bekrefte den",
  "verification.back-button": "Tilbake",
  "two-step.password.title": "Passord",
  "two-step.password.description": "Skriv inn passordet tilknyttet kontoen din",
  "two-step.code.title": "E-postkode",
  "two-step.code.description": "En verifiseringskode vil bli sendt til din e-post",
  "two-step.webauthn.title": "Sikkerhetsnøkkel",
  "two-step.webauthn.description": "Bruk sikkerhetsnøkkelen din for å autentisere",
  "two-step.passkey.title": "Passkey (anbefalt)",
  "two-step.passkey.description": "Bruk enheten din for fingeravtrykk eller ansiktsgjenkjenning",
  "two-step.totp.title": "Bruk autentiseringsapp (TOTP)",
  "two-step.totp.description": "Bruk en 6-sifret engangskode fra autentiseringsappen din",
  "two-step.lookup_secret.title": "Backup gjenopprettingskode",
  "two-step.lookup_secret.description": "Bruk en av dine 8-sifrede backupkoder for å autentisere",
  "identities.messages.1010020": "",
  "input.placeholder": "Skriv inn din {placeholder}",
  "card.header.parts.oidc": "en sosial leverandør",
  "card.header.parts.password.registration": "din {identifierLabel} og et passord",
  "card.header.parts.password.login": "din {identifierLabel} og passord",
  "card.header.parts.code": "en engangskode",
  "card.header.parts.passkey": "en passkey",
  "card.header.parts.webauthn": "en sikkerhetsnøkkel",
  "card.header.parts.totp": "din autentiseringsapp",
  "card.header.parts.lookup_secret": "en backup gjenopprettingskode",
  "card.header.parts.identifier-first": "din {identifierLabel}",
  "card.header.description.login": "Logg inn med {identifierLabel}",
  "card.header.description.registration": "Registrer deg med {identifierLabel}",
  "misc.or": "eller",
  "forms.label.recover-account": "Gjenopprett kontoen",
  "forms.label.forgot-password": "Glemt passord?",
  "settings.totp.title": "Autentiseringsapp",
  "settings.totp.description": "Legg til en TOTP-autentiseringsapp til kontoen din for å forbedre sikkerheten. Populære autentiseringsapper er LastPass og Google Authenticator",
  "settings.totp.info.not-linked": "For å aktivere, skann QR-koden med autentiseringsappen og skriv inn koden.",
  "settings.totp.info.linked": "Du har for øyeblikket en autentiseringsapp tilkoblet.",
  "settings.lookup_secret.title": "Backup gjenopprettingskoder (andre faktor)",
  "settings.lookup_secret.description": "Gjenopprettingskoder er en sikker backup for 2FA, slik at du kan få tilgang til kontoen din hvis du mister 2FA-enheten.",
  "settings.oidc.title": "Tilkoblede kontoer",
  "settings.oidc.description": "Koble en sosial innloggingsleverandør til kontoen din.",
  "settings.oidc.info": "Tilkoblede kontoer fra disse leverandørene kan brukes til å logge inn på kontoen din",
  "settings.webauthn.info": "Maskinvaretokener brukes for tofaktorautentisering eller som første faktor med passkeys",
  "settings.passkey.title": "Administrer passkeys",
  "settings.passkey.description": "Administrer innstillingene for passkeys",
  "settings.passkey.info": "Administrer innstillingene for passkeys",
  "card.footer.select-another-method": "Velg en annen metode",
  "account-linking.title": "Koble konto",
  "property.password": "passord",
  "property.email": "e-post",
  "property.phone": "telefon",
  "property.username": "brukernavn",
  "property.identifier": "identifikator",
  "property.code": "kode",
  "consent.title": "Autoriser {party}",
  "consent.subtitle": "En tredjepartsapplikasjon ønsker å få tilgang til informasjon tilknyttet kontoen din {identifier}.",
  "consent.scope.openid.title": "Identitet",
  "consent.scope.openid.description": "Lar applikasjonen verifisere identiteten din. Dette er nødvendig for autentisering og en trygg innloggingsopplevelse.",
  "consent.scope.offline_access.title": "Frakoblet tilgang",
  "consent.scope.offline_access.description": "Lar denne applikasjonen holde deg innlogget selv når du ikke bruker den aktivt.",
  "consent.scope.profile.title": "Profilinformasjon",
  "consent.scope.profile.description": "Gir tilgang til grunnleggende profildetaljer, inkludert brukernavn, fornavn og etternavn.",
  "consent.scope.email.title": "E-postadresse",
  "consent.scope.email.description": "Hent e-postadressen din og dens verifiseringsstatus.",
  "consent.scope.address.title": "Postadresse",
  "consent.scope.address.description": "Få tilgang til postadressen din.",
  "consent.scope.phone.title": "Telefonnummer",
  "consent.scope.phone.description": "Hent telefonnummeret ditt og dets verifiseringsstatus.",
  "error.title.what-happened": "Hva skjedde?",
  "error.title.what-can-i-do": "Hva kan jeg gjøre?",
  "error.instructions": "Vennligst prøv igjen om noen minutter eller kontakt nettstedets operatør.",
  "error.footer.text": "Når du rapporterer denne feilen, vennligst inkluder følgende informasjon:",
  "error.footer.copy": "Kopier",
  "error.action.go-back": "Gå tilbake",
  "settings.messages.toast-title.error": "Kunne ikke oppdatere innstillinger",
  "settings.messages.toast-title.success": "Innstillinger oppdatert",
  "two-step.passkey.description.error": "Kunne ikke laste de nødvendige bibliotekene for å bruke passordet ditt. \nVennligst prøv igjen senere."
}
